export default __webpack_public_path__ + "static/media/GSTD.65db06d8.png";